import React, { useState, useEffect } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { auth } from "../firebaseConfig";
import { onAuthStateChanged } from "firebase/auth";

const PrivateRoute = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const location = useLocation();

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      setUser(currentUser);
      setLoading(false);
    });
    return () => unsubscribe();
  }, []);

  if (loading) {
    return (
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '60vh',
        gap: '16px',
        fontFamily: 'var(--font-body)',
        color: '#64748b'
      }}>
        <div style={{
          width: '36px',
          height: '36px',
          border: '3px solid #E2E8F0',
          borderTopColor: '#1769E8',
          borderRadius: '50%',
          animation: 'authSpin 0.8s linear infinite'
        }} />
        <p style={{ fontSize: '14.5px', margin: 0 }}>Checking authentication...</p>
      </div>
    );
  }

  return user ? children : <Navigate to="/login-message" state={{ from: location.pathname }} />;
};

export default PrivateRoute;
